export default __webpack_public_path__ + "static/media/large.9c4d4847.jpg";